<script>
  import { onMount, onDestroy } from 'svelte';
  import { user, accessToken, loading } from '$lib/stores/store';
  import { getRefreshToken, saveRefreshToken, clearRefreshToken } from '$lib/db/indexeddb';

  import Home from '@routes/Home.svelte';
  import Login from '@routes/Login.svelte';
  import Loading from '@components/loading/index.svelte';
  import { connectWebSocket, closeSocket } from '$lib/websocket-client.js';
  import { initTheme } from '$lib/theme';
  import { initMenus } from '$lib/stores/menuService';

  import NotificationContainer from '@components/toast/NotificationContainer.svelte';
  import ConfirmDialog from '@components/toast/ConfirmDialog.svelte';
  import LoadingOverlay from '@components/toast/LoadingOverlay.svelte';

  import ApiClient from '$lib/api';
  const api = new ApiClient();

  let hasWarned = false;
  let unsubscribeToken;

  // ========== AUTH CHECK ==========
  // const checkAuth = async () => {
  //   try {
  //     let token = $accessToken;

  //     // Không có accessToken → dùng refreshToken
  //     if (!token) {
  //       const refreshToken = await getRefreshToken();
  //       if (refreshToken) {
  //         const res = await api.post('/auth/refresh', { refreshToken }, { withCredentials: true });
  //         token = res.accessToken;
  //         await accessToken.set(token);

  //         if (res.refreshToken) {
  //           await saveRefreshToken(res.refreshToken);
  //         }
  //       }
  //     }

  //     // Nếu có accessToken → gọi /auth/me xác thực user
  //     if (token) {
  //       const res = await api.get('/auth/me', {
  //         headers: { Authorization: `Bearer ${token}` },
  //         withCredentials: true
  //       });
  //       user.set(res.user);
  //     } else {
  //       user.set(null);
  //     }
  //   } catch (err) {
  //     console.warn('Auto refresh failed:', err);
  //     accessToken.set('');
  //     user.set(null);
  //     await clearRefreshToken();
  //   }
  // };

  async function checkAuth() {
    try {
      const res = await api.get('/auth/me');
      user.set(res.user);
      return true;
    } catch {
      user.set(null);
      return false;
    }
  }

  // ========== LIFECYCLE ==========
  onMount(async () => {
    loading.set(true);

    await initMenus();

    await checkAuth();

    initTheme();

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handleGoBack);

    unsubscribeToken = accessToken.subscribe((token) => {
      if (token) {
        console.log('🔑 accessToken ready → connect WS');
        connectWebSocket();
      } else {
        console.log('🚪 accessToken cleared → close WS');
        closeSocket();
      }
    });

    loading.set(false);
  });

  onDestroy(() => {
    unsubscribeToken?.();
    closeSocket();
    window.removeEventListener('beforeunload', handleBeforeUnload);
    window.removeEventListener('popstate', handleGoBack);
  });

  // ========== WARN BEFORE EXIT ==========
  function handleBeforeUnload(e) {
    if ($user) {
      e.preventDefault();
      e.returnValue = '';
    }
  }

  function handleGoBack() {
    if ($user && !hasWarned) {
      const confirmLeave = confirm('Bạn có chắc muốn rời khỏi ứng dụng không?');
      if (!confirmLeave) {
        history.pushState(null, '', location.href);
      } else {
        hasWarned = true;
        history.back();
      }
    }
  }
</script>

{#if $loading}
  <!-- <Home /> -->
  <Loading />
{:else if $user}
  <Home />
{:else}
  <!-- <Home /> -->
  <Login />
{/if}

<NotificationContainer />
<ConfirmDialog />
<LoadingOverlay />
